/**
 * ✨ Анімація «товар летить у кошик»: ghost-копія картинки картки
 * летить до елемента з [data-cart-anchor] (або в правий верхній кут).
 * Чистий DOM, best-effort — будь-яка помилка мовчки ігнорується.
 */
export function flyToCart(
  imgEl: HTMLImageElement | null | undefined,
  coverUrl: string,
): void {
  try {
    if (!import.meta.client || !imgEl || !coverUrl) return;
    const from = imgEl.getBoundingClientRect();
    const target = document.querySelector("[data-cart-anchor]");
    const to = target
      ? target.getBoundingClientRect()
      : { left: innerWidth - 40, top: 16, width: 24, height: 24 };

    const ghost = document.createElement("img");
    ghost.src = imgEl.currentSrc || imgEl.src || coverUrl;
    ghost.alt = "";
    Object.assign(ghost.style, {
      position: "fixed",
      left: `${from.left}px`,
      top: `${from.top}px`,
      width: `${from.width}px`,
      height: `${from.height}px`,
      objectFit: "cover",
      borderRadius: "12px",
      zIndex: "9999",
      transition: "transform 450ms cubic-bezier(.2,.8,.2,1), opacity 450ms",
      willChange: "transform, opacity",
    });
    document.body.appendChild(ghost);

    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const scale = 0.12;

    requestAnimationFrame(() => {
      ghost.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
      ghost.style.opacity = "0.35";
    });
    ghost.addEventListener("transitionend", () => ghost.remove(), {
      once: true,
    });
  } catch {
    /* ignore */
  }
}
